import React from "react";
import { Button } from "antd";
import Progress from "./Progress";
import flameGif from "../../assets/images/flame.gif";
import clapGif from "../../assets/images/clap.gif";
import { useLocation, useNavigate } from "react-router-dom";

const GameResult = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { score, totalWords, currentIndex, id } = location.state || {
    score: 0,
    totalWords: 0,
    currentIndex: 0,
    id: {},
  };

  const handleGoBack = () => {
    navigate(`/card-game/${id}`, { state: { currentIndex, id } });
  };

  return (
    <div className="relative w-full max-w-[1400px] p-6 2xl:p-0 m-auto flex flex-col items-center justify-center bg-white">
      {score === totalWords ? (
        <div className="w-full mx-auto space-y-10 text-center pt-[50px] md:pt-[80px]">
          <img src={flameGif} alt="폭죽 이미지" className="word-result-img" />

          <div className="word-result-message">
            <h3>축하해요!</h3>
            <p>모든 단어카드를 복습했어요!</p>
          </div>

          <div className="word-progress">
            <h4>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="27"
                viewBox="0 0 33 27"
                fill="none"
              >
                <path
                  d="M14.6503 23.4167H30.7003M9.30033 19.85L4.84199 25.2L2.16699 23.4167M14.6503 14.5H30.7003M9.30033 10.9333L4.84199 16.2833L2.16699 14.5M14.6503 5.58333H30.7003M9.30033 2.01666L4.84199 7.36666L2.16699 5.58333"
                  stroke="#3D90EF"
                  strokeWidth="3.56667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              완료한 단어 {score}개
            </h4>
            <h4>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="43"
                viewBox="0 0 44 43"
                fill="none"
              >
                <path
                  d="M12.2241 37.55H37.1383C37.6597 37.55 38.0828 37.1275 38.0828 36.6061L38.0824 26.0106M14.8643 36.9639L37.4442 26.4347C37.9168 26.2143 38.1211 25.6524 37.9007 25.1799L33.4229 15.5779C33.2026 15.1053 32.6407 14.9002 32.1682 15.1205L22.0864 19.8221M18.255 32.9219C17.3628 36.2516 13.9403 38.2276 10.6106 37.3354C7.28084 36.4432 5.30443 33.021 6.19662 29.6913L12.6449 5.62591C12.7798 5.12225 13.2971 4.82325 13.8007 4.95821L24.0352 7.70006C24.5389 7.83501 24.8378 8.35256 24.7028 8.85622L18.255 32.9219ZM12.2241 31.4869H12.2277L12.2276 31.4904L12.2241 31.4903V31.4869Z"
                  stroke="#3D90EF"
                  strokeWidth="3.56667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              남은 단어 {totalWords - score}개
            </h4>
          </div>
        </div>
      ) : (
        <div className="w-full mx-auto space-y-10 text-center pt-[50px] md:pt-[80px]">
          <img
            src={clapGif}
            alt="박수 이미지"
            style={{
              width: "450px",
              height: "auto",
              margin: "0 auto",
            }}
          />

          <div className="word-result-message">
            <h3>굉장해요!</h3>
            <p>오늘은 단어를 이렇게 많이 공부했네요!</p>
          </div>

          <div className="word-progress">
            <h4>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="27"
                viewBox="0 0 33 27"
                fill="none"
              >
                <path
                  d="M14.6503 23.4167H30.7003M9.30033 19.85L4.84199 25.2L2.16699 23.4167M14.6503 14.5H30.7003M9.30033 10.9333L4.84199 16.2833L2.16699 14.5M14.6503 5.58333H30.7003M9.30033 2.01666L4.84199 7.36666L2.16699 5.58333"
                  stroke="#3D90EF"
                  strokeWidth="3.56667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              완료한 단어 {score}개
            </h4>
            <Progress total={totalWords} score={score} />
            <h4>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="43"
                viewBox="0 0 44 43"
                fill="none"
              >
                <path
                  d="M12.2241 37.55H37.1383C37.6597 37.55 38.0828 37.1275 38.0828 36.6061L38.0824 26.0106M14.8643 36.9639L37.4442 26.4347C37.9168 26.2143 38.1211 25.6524 37.9007 25.1799L33.4229 15.5779C33.2026 15.1053 32.6407 14.9002 32.1682 15.1205L22.0864 19.8221M18.255 32.9219C17.3628 36.2516 13.9403 38.2276 10.6106 37.3354C7.28084 36.4432 5.30443 33.021 6.19662 29.6913L12.6449 5.62591C12.7798 5.12225 13.2971 4.82325 13.8007 4.95821L24.0352 7.70006C24.5389 7.83501 24.8378 8.35256 24.7028 8.85622L18.255 32.9219ZM12.2241 31.4869H12.2277L12.2276 31.4904L12.2241 31.4903V31.4869Z"
                  stroke="#3D90EF"
                  strokeWidth="3.56667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              남은 단어 {totalWords - score}개
            </h4>
          </div>
        </div>
      )}

      <Button onClick={() => handleGoBack()} className="back-btn mt-5">
        마지막 단어로 돌아가기
      </Button>
    </div>
  );
};

export default GameResult;
